import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, mapMany } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";

export interface Props {
    entregas: Observable<models.EntregaZERealizadaDTO[]>;
    onLiberar: () => void;
}

/**
 * Muestra el listado de las guias que van a generar acuses
 */
export class LiberacionComp extends React.PureComponent<Props> {
    entregas = (props: Props) => props.entregas;
    total = createSelectorRx(this.entregas, entregas => entregas.map(x => x.TotalFXC).reduce((a, b) => a + b, 0));
    render() {
        const importeTotal = this.total(this.props);
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <PagoComp importeTotal={importeTotal} />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-12">
                        <kea.Button style="success" children="Liberar entregas" onClick={this.props.onLiberar} />
                    </div>
                </div>
            </div>
        )
    }
}

interface PropsPago {
    importeTotal: number;
}
class PagoCompNoEX extends React.PureComponent<PropsPago> {
    total = (x: PropsPago) => x.importeTotal;
    render() {
        const importeTotal = this.total(this.props);
        return (
            <h3 style={{ display: "inline" }}>
                <span className="label label-primary">
                    Total a entregar: <label>{kea.formatCurrency(importeTotal)}</label>
                </span>
            </h3>
        )
    }
}
const PagoComp = componentToRx(PagoCompNoEX);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/liberacionentregasZE/components/liberacion/index.tsx